import React, { useState, useEffect } from 'react';
import API from '../utils/api';

export default function ServiceModal({ slug, onClose }) {
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');

  useEffect(() => {
    if (!slug) return;
    setLoading(true);
    API.get(`/services/${slug}`)
      .then(res => { if (res.data.success) setService(res.data.data); })
      .catch(() => setError('Failed to load service details.'))
      .finally(() => setLoading(false));
  }, [slug]);

  // Close on Escape
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="svc-modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="svc-modal" role="dialog" aria-modal="true">
        <button className="svc-modal__close" onClick={onClose} aria-label="Close">✕</button>

        {loading && <div className="svc-modal__loading"><span className="spinner" /> Loading…</div>}
        {error   && <div className="svc-modal__error">{error}</div>}

        {service && (
          <>
            {service.imageUrl && (
              
                
                <div className="svc-modal__hero-fade" />
              
            )}
            <div className="svc-modal__body">
              <div className="svc-modal__icon">{service.icon}</div>
              <h2 className="svc-modal__title">{service.name}</h2>
              {service.description && <p className="svc-modal__desc">{service.description}</p>}

              {service.subServices?.length > 0 && (
                <>
                  <h3 className="svc-modal__sub-heading">Services</h3>
                  <div className="svc-modal__sub-list">
                    {service.subServices.map(sub => (
                      <div key={sub._id} className="svc-modal__sub-item">
                        <div className="svc-modal__sub-info">
                          <span className="svc-modal__sub-name">{sub.name}</span>
                          {sub.description && <span className="svc-modal__sub-desc">{sub.description}</span>}
                        </div>
                        <div className="svc-modal__sub-meta">
                          {sub.duration && <span className="svc-modal__sub-dur">{sub.duration}</span>}
                          {sub.price    && <span className="svc-modal__sub-price">{sub.price}</span>}
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}

              <a href="/#contact" className="svc-modal__book-btn" onClick={onClose}>
                ✦ Book This Service
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
